import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useProfile } from "../Components/Hooks/UserHooks";
import { APIClient } from "../helpers/api_helper";
import { GET_USER_PROFILE } from "../helpers/url_helper";

const AdminProtected = (props) => {
  const { userProfile, loading } = useProfile();
  const [profileLoading, setProfileLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const verifyAdminStatus = async () => {
      try {
        if (userProfile && !loading) {
          // First check if isAdmin is already in the profile
          if (userProfile.isAdmin) {
            setIsAdmin(true);
            setProfileLoading(false);
            return;
          }

          // If not, fetch from backend to get the latest admin status
          const api = new APIClient();
          const response = await api.get(GET_USER_PROFILE);
          
          if (response && response.data) {
            const userData = response.data;
            setIsAdmin(userData.isAdmin === true || userData.role === 'admin' || userData.role === 'ADMIN');
          } else {
            setIsAdmin(false);
          }
          setProfileLoading(false);
        }
      } catch (error) {
        console.error("Error verifying admin status:", error);
        setIsAdmin(false);
        setProfileLoading(false);
      }
    };

    verifyAdminStatus();
  }, [userProfile, loading]);

  if (loading || profileLoading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  // Check if user is admin
  if (!userProfile || !isAdmin) {
    return <Navigate to={{ pathname: "/dashboard" }} />;
  }

  return <>{props.children}</>;
};

export default AdminProtected;
